export default __webpack_public_path__ + "static/media/icon5.8dbacbde.svg";